import { render, staticRenderFns } from "./ConfigurationCard.vue?vue&type=template&id=570d00ee&scoped=true"
import script from "./ConfigurationCard.vue?vue&type=script&lang=js"
export * from "./ConfigurationCard.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCard.vue?vue&type=style&index=0&id=570d00ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d00ee",
  null
  
)

export default component.exports